module.exports = __webpack_public_path__ + "static/media/logo-previericsson.3e9bd421.png";